// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"36cdd1c5","453":"261726f2","491":"cdb9a5ef","966":"64fd0cec"}[chunkId] + ".chunk.js";
};